module.exports = "/fonts/vendor/dropify/dist/dropify.woff?950ffd1efa29c33a70dd86ea761cb3d8";